import { initPage } from '../api';
import { Message } from 'element-ui';
const recycling = {
  namespaced: true,
  state: {
    initPageObj: {},
  },
  mutations: {
    INIT_PAGE_DATA(state, resp) {
      state.initPageObj = resp.obj || {};
    }
  },
  actions: {
    async initPage({ commit }, obj) {
      let resp = await initPage(obj);
      commit('INIT_PAGE_DATA', resp);
    }
  }
}

export default recycling



// WEBPACK FOOTER //
// ./src/page/mytask/recycling/store/recycling.store.js